import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, CheckCircle2, Zap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const TONES = {
  red: 'bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20',
  blue: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
  purple: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
  orange: 'bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/20',
  emerald: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
  violet: 'bg-violet-500/10 text-violet-600 dark:text-violet-400 border-violet-500/20',
};

export const HubActionList = ({ items }) => {
  const { t } = useTranslation();
  return (
    <Card data-testid="hub-actions">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base md:text-lg">
          <Zap className="h-4 w-4 text-orange-500" /> {t('hub.actionsTitle')}
        </CardTitle>
        <CardDescription>{t('hub.actionsDesc')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {items.length === 0 ? (
          <div className="flex items-center gap-2 text-sm text-muted-foreground py-4" data-testid="hub-actions-empty">
            <CheckCircle2 className="h-4 w-4 text-emerald-500" /> {t('hub.noActions')}
          </div>
        ) : items.map((a) => (
          <Link
            key={a.key}
            to={a.to}
            data-testid={`hub-action-${a.key}`}
            className={`flex items-center justify-between gap-3 rounded-lg border px-3 py-2.5 text-sm transition-colors hover:brightness-95 dark:hover:brightness-110 ${TONES[a.tone] || TONES.orange}`}
          >
            <span className="flex items-center gap-2">
              <span className="inline-flex h-6 min-w-[24px] items-center justify-center rounded-full bg-background/70 px-1.5 text-xs font-bold tabular-nums">{a.count}</span>
              {t(`hub.action.${a.key}`, { count: a.count })}
            </span>
            <ArrowRight className="h-4 w-4 shrink-0" />
          </Link>
        ))}
      </CardContent>
    </Card>
  );
};
